import { useEffect, useState } from 'react'
import { API, Endpoints } from '@brg/api'

export enum ROLES {
  none = 'none',
  student = 'student',
  teacher = 'teacher',
  jury = 'jury',
}

export const useCoursesRole = (projectId: string, longreadId: string ) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState();
  const [response, setResponse] = useState<string>(ROLES.none);

  const rolesMap: { [key: string]: ROLES } = {
    1: ROLES.student,
    2: ROLES.teacher,
    3: ROLES.jury,
  };

  const fetch = async () => {
    setIsLoading(true)
    await API.request()
      .endpoint(Endpoints.geograffee)
      .url('/api/LMS/GetAccessType')
      .addQuery('projectId', projectId)
      .addQuery('themeLongreadId', longreadId)
      .get()
      .send()
      .then((r) => r.json())
      .then((r: number) =>
        setResponse(rolesMap[r] ?? ROLES.none)
      )
  }

  useEffect(() => {
    fetch();
  }, [])


  useEffect(() => {
    if (response || error) {
      setIsLoading(false)
    }
  }, [response, error])

  if (!projectId || !longreadId) {
    return null
  }

  return [response, isLoading, error]
}
import { useEffect, useState } from 'react'
import { API, Endpoints } from '@brg/api'

export enum ROLES {
  none = 'none',
  student = 'student',
  teacher = 'teacher',
  jury = 'jury',
}

export const useCoursesRole = (projectId: string, longreadId: string ) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState();
  const [response, setResponse] = useState<string>(ROLES.none);

  const rolesMap: { [key: string]: ROLES } = {
    1: ROLES.student,
    2: ROLES.teacher,
    3: ROLES.jury,
  };

  const fetch = async () => {
    setIsLoading(true)
    await API.request()
      .endpoint(Endpoints.geograffee)
      .url('/api/LMS/GetAccessType')
      .addQuery('projectId', projectId)
      .addQuery('themeLongreadId', longreadId)
      .get()
      .send()
      .then((r) => r.json())
      .then((r: number) =>
        setResponse(rolesMap[r] ?? ROLES.none)
      )
  }

  useEffect(() => {
    fetch();
  }, [])


  useEffect(() => {
    if (response || error) {
      setIsLoading(false)
    }
  }, [response, error])

  if (!projectId || !longreadId) {
    return null
  }

  return [response, isLoading, error]
}
